import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=ed21acf8&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=ts"
export * from "./OrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./OrdersTable.vue?vue&type=style&index=0&id=ed21acf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21acf8",
  null
  
)

export default component.exports